import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class TitleRenderer extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { value, data } = this.props;
    if (!data) {
      return null;
    }
    return (
      <div>
        <Link to={`/admin/news/${data._id}`}>{(value || 'untitled')}</Link>
      </div>
    );
  }
}

TitleRenderer.propTypes = {
  value: PropTypes.number,
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }),
};
TitleRenderer.defaultProps = {
  value: null,
  data: null,
};


export default TitleRenderer;
